import script from "./CourseTest.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseTest.vue?vue&type=script&setup=true&lang=js"

import "./CourseTest.vue?vue&type=style&index=0&id=8113d55c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8113d55c"]])

export default __exports__